<template>
  <div class="passenger-discount">
    <label
      class="octobus__label is-size-7-touch has-text-grey has-text-weight-light"
      :for="`contact-info__discount_${id}`"
    >
      {{$t('discount.discount')}}
    </label>
    <div class="octobus__select is-medium octobus__control is-fullwidth">
      <select
        :name="`contact-info__discount_${id}`"
        :id="`contact-info__discount_${id}`"
        @change="setLgotes" v-model="internalSelectedCode"
      >
        <option value="full">{{$t('discount.full')}}</option>
        <option v-if="promoCode" :value="promoCode.code">{{promoCode.name}}</option>
        <option :value="lgot.code" v-for="(lgot, index) of lgotes" :key="index">{{lgot.name}}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Discount',
  components: {
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    autoLgot: {
      type: Object,
    },
    lgotes: {
      type: Array,
    },
    selectedCode: {
      type: String,
    },
    promoCode: {
      type: Object,
    },
    raceId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      internalSelectedCode: 'full',
    };
  },
  methods: {
    setLgotes(event) {
      this.internalSelectedCode = event.target.value;
      this.emitSelectedLgotes();
    },
    emitSelectedLgotes() {
      this.$emit('selectedLgotes', {
        code: this.internalSelectedCode === 'full' ? this.getAutoLgotCode() : this.internalSelectedCode,
      }, this.raceId);
    },
    getAutoLgotCode() {
      return this.autoLgot ? this.autoLgot.code : '';
    },
  },
  mounted() {
    this.emitSelectedLgotes();
  },
  watch: {
    selectedCode(newVal) {
      this.internalSelectedCode = (this.getAutoLgotCode() === newVal) ? 'full' : (newVal || 'full');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Passenger/Discount.vue